import { render } from "./Analytics.vue?vue&type=template&id=3b12264f&scoped=true"
import script from "./Analytics.vue?vue&type=script&lang=js"
export * from "./Analytics.vue?vue&type=script&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=3b12264f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b12264f"]])

export default __exports__